//ContentfulModuleServiceSection
import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { H1 } from "../../atomic/atoms/type/H1"
import { COLORS, TYPE } from "../../../theme/styles/globals"
import { MODE, ALIGN } from "../globals"
import Blocks from "../blocks/blocks"

export default class ContentfulModuleServiceSection extends React.Component {
  renderBlock(__typename, props, mode, index) {
    return (ContentfulBlock => (
      <ContentfulBlock {...props} mode={mode} number={index} />
    ))(Blocks[__typename])
  }

  render() {
    const { mode, blocks } = this.props

    return (
      <Container mode={mode}>
        <Title>Services</Title>
        {blocks.map((block, i) => {
          return (
            <BlockWrap key={i}>
              {this.renderBlock(block.__typename, block, mode, i + 1)}
            </BlockWrap>
          )
        })}
      </Container>
    )
  }
}

const Container = styled.section`
  width: 100%;
  height: auto;
  background-color: ${props =>
    props.mode === MODE.LIGHT ? `${COLORS.WHITE}` : `${COLORS.DARK_GREY_1}`};
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 50px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;

  ${up("md")} {
    padding-top: 0px;
    padding-bottom: 0px;
    flex-direction: row;
    width: auto;
    height: 100vh;
    padding-left: 0px;
    padding-right: 150px;
    justify-content: center;
    align-items: center;
  }
`

const Title = styled(H1)`
  color: ${COLORS.WHITE};
  font-size: 72px;
  margin-bottom: 50px;

  ${up("md")} {
    margin-bottom: 0px;
    font-size: 174px;
    color: ${COLORS.DARK_GREY_4};
    padding-bottom: 600px;
    transform: translateX(188px);
  }
`

const BlockWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  z-index: 4;
`
